import { useState } from 'react';

export default function useOperationState() {
  // 是否重新操作过复选器提交
  const [isNewConfirm, setIsNewConfirm] = useState(true);
  // 是否重新勾选过游戏
  const [isNewCheckGame, setIsNewCheckGame] = useState(true);
  // 真正的是否重新勾选游戏，上面那个 isNewCheckGame 需要做优化处理
  const [operatedGame, setOperatedGame] = useState(false);

  return { isNewConfirm, setIsNewConfirm, isNewCheckGame, setIsNewCheckGame, operatedGame, setOperatedGame };
}
